import React from "react";
import { FaHome, FaPhone, FaMailBulk, FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
          <div className="location">
            <FaHome size={20} style={{ color: "white", marginRight: "1rem" }} />
            <p>Toronto, Ontario</p>
          </div>

          <div className="phone-number">
            <h4>
              <FaPhone
                size={20}
                style={{ color: "white", marginRight: "1rem" }}
              />
              647-882-8194
            </h4>
          </div>
          <div className="email">
            <h4>
              <FaMailBulk
                size={20}
                style={{ color: "white", marginRight: "1rem" }}
              />
              Daveshea6@gmail.com
            </h4>
          </div>
        </div>
        <div className="right">
          <h4 className="about-me">About Me</h4>
          <p className="description">
            I am a full stack developer with 3+ years experience specializing in
            React, Javascript & Nodejs. I primarily build applications with the MERN stack. 
          </p>
          <div className="social-media">
          <Link to='https://github.com/davey2000'>
          <FaGithub size={30} style={{ color: "white" }} />
          </Link>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
